export default __webpack_public_path__ + "c40f75e09386a74fd25a4a754e2e2dfe.svg";